type FieldFormatter = (value: any) => any;

/**
 * Normaliza filtros para exportación server-side: descarta paginado (take/skip),
 * valores vacíos, y desenvuelve objetos { id } / { value } a su valor primitivo.
 * `fieldFormatters` permite pasar formatters específicos por campo (ej. fechas).
 */
export const normalizeExportFilters = (
    filters: Record<string, any> = {},
    extraFilters: Record<string, any> = {},
    fieldFormatters: Record<string, FieldFormatter> = {}
) => {
    const merged = { ...filters, ...extraFilters };
    const { take, skip, ...rest } = merged;

    return Object.entries(rest).reduce((acc: Record<string, any>, [key, value]) => {
        if (value === undefined || value === null || value === '') return acc;

        if (fieldFormatters[key]) {
            const formatted = fieldFormatters[key](value);
            if (formatted !== undefined && formatted !== null && formatted !== '') {
                acc[key] = formatted;
            }
            return acc;
        }

        if (typeof value === 'object' && !Array.isArray(value)) {
            const normalizedValue = (value as any)?.id ?? (value as any)?.value ?? null;
            if (normalizedValue !== null && normalizedValue !== '') {
                acc[key] = normalizedValue;
            }
            return acc;
        }

        acc[key] = value;
        return acc;
    }, {});
};
